import "./Style/About.css";
import Try from "../testing/Try";

export default function About() {
  return (
    <>
      <Try />

      <div className="my-container">
        <h1>
          Welcome to our website, dedicated to the Jain religion and the holy
          site of Sikharji. We are a team of Jain scholars and enthusiasts who
          are passionate about sharing our knowledge and love of this ancient
          faith with the world.
        </h1>
        <hr />
        On our website, you will find a wealth of information about Jainism,
        including its history, philosophy, and practices. We also offer a
        variety of resources for learning more about Sikharji, one of the most
        important pilgrimage sites for Jains.
        <hr />
        <h1>
          Whether you are a lifelong Jain or simply curious about this
          fascinating religion, we hope you will find our website to be a
          valuable resource. We welcome your feedback and suggestions, and we
          hope you will join us in our mission to promote Jainism and Sikharji
          to the world.
        </h1>
      </div>
    </>
  );
}
